export const GET_BANNER_ALERT_MESSAGE = "GET_BANNER_ALERT_MESSAGE";
export const LOADER_FOR_BANNER_ALERT_MESSAGE = "LOADER_FOR_BANNER_ALERT_MESSAGE";
export const RESET_FOR_BANNER_ALERT_MESSAGE = "RESET_FOR_BANNER_ALERT_MESSAGE";

export interface IAlertMessageBannerState {
    alertMessageBanner?: AlertMessageBanner[];
    isLoadingBannerMessage: boolean;
}

export interface AlertMessageBanner {
    alertid?: number;
    message?: string;
    messageLevel?: string;
    beginViewDate?: any;
    endViewDate?: any;
    forDisplayKey?: string;
    displayScope?: string;
    allowDismiss?: boolean;
    actorClass?:string;
}

export interface getBannerAlertMessageAction {
    type: "GET_BANNER_ALERT_MESSAGE";
    alertMessageBanner: AlertMessageBanner[];
}
export interface changeBannerAlertMessageLoaderAction {
    type: "LOADER_FOR_BANNER_ALERT_MESSAGE";
    isLoadingBannerMessage: boolean;
}
export interface resetBannerAlertMessageLoaderAction {
    type: "RESET_FOR_BANNER_ALERT_MESSAGE";
}
export type KnownAction = getBannerAlertMessageAction | changeBannerAlertMessageLoaderAction | resetBannerAlertMessageLoaderAction;
